export const hideVehicleToolbar = () => {
	const vehicleToolbar = document.querySelector(
		'div[data-name="vdp-sticky-vehicle-toolbar-wrapper-1"]'
	);
	
	if (vehicleToolbar) {
		vehicleToolbar.classList.add('d-none');
	}
};